// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import LoadingIcon from '../../../../components/LoadingIcon';
import { actionCreatorsList } from '../../../../redux/rootActionCreator';
import LabSelector from '../../../../redux/selectors/LabSelector';
import { CompletionStatusType } from '../../../../types/Model';

import { S } from './styles';

interface LabModuleProps {
  id: number;
  status?: CompletionStatusType;
  courseId: number;
  courseType: string;
  triggerProgress: () => void;
  handleNextModule: () => void;
}

function useGetLabInformation(id: number) {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(actionCreatorsList.getLabInformationActions.request({
      id,
      condition: 'buy'
    }))
  }, [id]);
}

const LabContent: React.FC<LabModuleProps> = ({ id, status, triggerProgress, handleNextModule, courseId, courseType }): JSX.Element => {
  const lab = useSelector(LabSelector.makeLabByIdSelector(id));
  const isLabFetching = useSelector(LabSelector.makeIsFetchingLab());
  const fromWorkshop = courseType === 'workshops' ? `?workshopId=${courseId}` : ''
  const fromCourse = courseType === 'onlineCourses' ? `?courseId=${courseId}` : ''
  const fromIltCourse = courseType === 'iltCourses' ? `?iltCourseId=${courseId}` : ''
  const labUrl = `/labs/${id}${fromWorkshop}${fromCourse}${fromIltCourse}`
  const getLabInformation = useGetLabInformation(id);

  useEffect(() => {
    getLabInformation();
  }, [id])

  if (isLabFetching) {
    return (
      <S.Container>
        <LoadingIcon size={15} />
      </S.Container>
    );
  }

  return (
    <S.Container>
      <S.Row>
        <S.InformationContainer>
          <S.Title><FormattedMessage id="F024" />{lab.name}</S.Title>
          <S.Overview>{lab.overview}</S.Overview>
        </S.InformationContainer>
        <S.LabImage />
      </S.Row>
      <S.Row>
        <S.Button as={Link} to={labUrl} target="_blank"><FormattedMessage id="F014" /></S.Button>
        {status === CompletionStatusType.COMPLETED && <S.Button onClick={handleNextModule}><FormattedMessage id="F015" /></S.Button>}
      </S.Row>
    </S.Container>
  );
}

export { LabContent as default };
